module.exports = __webpack_public_path__ + "img/1.f542faa6.png";